import { SchoolEnrollment } from './school-enrollment.model';
import { StudentTerminationStatus } from './student-termination-status.model';
export class StudentTerminationStatusGraduation {
    ID: number;
    STUDENT_TERMINATION_STATUSES_ID: number;
    SCHOOL_ENROLLMENTS_ID: number;
    CREATED_BY: string;
    CREATED_DATE: Date;
    MODIFIED_BY: string;
    MODIFIED_DATE: Date;
    STUDENT_TERMINATION_STATUS: StudentTerminationStatus;
    SCHOOL_ENROLLMENT: SchoolEnrollment;
}
